import { useQuery } from '@tanstack/react-query';
import { cacheAdminApi } from '../api/cacheAdminApi';

/**
 * GET /api/eraf/cache-admin/caches/{name} — 캐시 상세 (CACHE_READ)
 * queryKey: ['cache-admin', 'detail', name]
 */
export function useCacheDetail(name: string | null) {
  return useQuery({
    queryKey: ['cache-admin', 'detail', name],
    queryFn: () => cacheAdminApi.getCacheDetail(name!),
    enabled: !!name,
    staleTime: 30_000,
  });
}
